import { Owner } from "../Viewer/Owner";
import { DeviceGroup } from "../../DiscoveryEngine.TS/Core/DeviceGroup";
import { ViewerDeviceGroupTreeNodeDto } from "./ViewerDeviceGroupTreeNodeDto";
import { DeviceGroupContainer } from "../../DiscoveryEngine.TS/Core/DeviceGroupContainer";
import { List } from "../../DiscoveryEngine.TS/Utils";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";

export class ViewerDeviceGroupDto extends ViewerDeviceGroupTreeNodeDto {

	public DeviceGroup: DeviceGroup;
	public ChildGroupGuids: List<string>;

	constructor(userGuid?: string, scopeGuid?: string, owner?: Owner, image?: string,
		name?: string, tagGuid?: string, deviceGroup?: DeviceGroup, childGroupGuids?: List<string>) {
		super(userGuid, scopeGuid, owner, image, name, tagGuid);

		this.DeviceGroup = (deviceGroup ? deviceGroup : null);
		this.ChildGroupGuids = (childGroupGuids ? childGroupGuids : new List<string>());
	}

	public get HasDeviceGroup(): boolean {
		return !!this.DeviceGroup;
	}

	public get HasChildDeviceGroupGuids(): boolean {
		return !!this.ChildGroupGuids && this.ChildGroupGuids.Count > 0;
	}

	public Write(obj: any, context: any): void {
		obj.viewer_device_group = {};
		obj = obj.viewer_device_group;

		super.Write(obj, context);

		if (this.HasDeviceGroup) {
			this.DeviceGroup.Write(obj, context);
		}
		if (this.HasChildDeviceGroupGuids) {
			obj.child_group_guids = []
			ObjSerUtils.WriteStringCollection(obj.child_group_guids, this.ChildGroupGuids, "value", context);
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.viewer_device_group)
			throw new Error();
		obj = obj.viewer_device_group;

		super.Read(obj, context);

		if (obj.device_group !== undefined) {
			this.DeviceGroup = new DeviceGroup();
			this.DeviceGroup.Read(obj, context);
		}
		if (obj.child_group_guids !== undefined) {
			this.ChildGroupGuids.Clear();
			ObjSerUtils.ReadStringCollection(obj.child_group_guids, this.ChildGroupGuids, "value", context);
		}
	}

}